var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Copied from 3rd party tool source code
// Source: https://github.com/ariakit/ariakit/blob/reakit%401.2.2/packages/reakit/src/Popover/__keys.ts
var POPOVER_STATE_KEYS = [
    'baseId',
    'unstable_idCountRef',
    'visible',
    'animated',
    'animating',
    'setBaseId',
    'show',
    'hide',
    'toggle',
    'setVisible',
    'setAnimated',
    'stopAnimation',
    'modal',
    'unstable_disclosureRef',
    'setModal',
    'unstable_referenceRef',
    'unstable_popoverRef',
    'unstable_arrowRef',
    'unstable_popoverStyles',
    'unstable_arrowStyles',
    'unstable_originalPlacement',
    'unstable_update',
    'placement',
    'place',
];
export var POPOVER_KEYS = POPOVER_STATE_KEYS;
export var POPOVER_ARROW_KEYS = __spreadArray(__spreadArray([], __read(POPOVER_KEYS), false), ['size'], false);
//# sourceMappingURL=__keys.js.map